define('helper-entity-isTaskPage',["exports"], function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function (entity) {
        return entity && Array.isArray(entity.questions) && Array.isArray(entity.answers) && (entity.questions.length || entity.answers.length) ? true : false;
    };
});
